import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class StatisticsService {

  constructor(private http: HttpClient) { }

  GetNewInstitutionsAndCampsPerYearReport(input: any) {
    return this.http.post<any>(environment.apiUrl + 'Statistics/GetNewInstitutionsAndCampsPerYearReport/', input);
  }

  GetAttendanceStatisticsPerMeetingReport(input: any) {
    return this.http.post<any>(environment.apiUrl + 'Statistics/GetAttendanceStatisticsPerMeetingReport/', input);
  }

  GetMsFlowReport(input: any) {
    return this.http.post<any>(environment.apiUrl + 'Statistics/GetMsflowReport/', input);
  }

  GetAttendanceStatisticsPerInstitutionReport(input: any) {
    return this.http.post<any>(environment.apiUrl + 'Statistics/GetAttendanceStatisticsPerInstitutionReport/', input);
  }

  GetAttendanceStatisticsPerInstitutionPerMonthReport(input: any) {
    return this.http.post<any>(environment.apiUrl + 'Statistics/GetAttendanceStatisticsPerInstitutionPerMonthReport/', input);
  }

  GetAttendanceStatisticsPerInstitutionWithinDistrictReport(input: any) {
    return this.http.post<any>(environment.apiUrl + 'Statistics/GetAttendanceStatisticsPerInstitutionWithinDistrictReport/', input);
  }

  GetAttendanceStatisticsPerMemberReport(input: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Statistics/GetAttendanceStatisticsPerMemberReport/', JSON.stringify(input), httpOptions);
  }

  GetCausesStatisticsReport(input: any) {
    return this.http.post<any>(environment.apiUrl + 'Statistics/GetCausesStatisticsReport/', input);
  }

}
